import {isMobile} from "../helpers"
export default () => ({
    open: false,
    text:'info +',
    disabled:false,
    init() {
    },
    onInfoModalClose(){
        if(isMobile()){
            this.disabled=false;
            this.$dispatch('close-modal')
            this.text = "info +"
            window.dispatchEvent(new CustomEvent('info-modal-closed'));
            return;
        }
    },
    onToggleModalInfo(){
        
        this.disabled=true;

        if(isMobile()){
            window.dispatchEvent(new CustomEvent('open-info-modal'));
            this.$dispatch('open-modal')
            this.text = ""
            return;
        }


        if(this.text==="info +"){
            
            this.text = "close"
            this.$dispatch('open-modal')
        } else {
            this.text = "info +"
            this.$dispatch('close-modal')
        }

        setTimeout(() => {
            this.disabled=false;
        }, 1000);
    }
})